import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d8f3fdb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rebalancing-history-table" }
const _hoisted_2 = {
  key: 0,
  class: "section-title"
}
const _hoisted_3 = {
  key: 1,
  class: "loading-container"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "加载中...", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 2,
  class: "error-container"
}
const _hoisted_8 = {
  key: 3,
  class: "table-wrapper"
}
const _hoisted_9 = { class: "history-table" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "调仓时间"),
    /*#__PURE__*/_createElementVNode("th", null, "代码"),
    /*#__PURE__*/_createElementVNode("th", null, "名称"),
    /*#__PURE__*/_createElementVNode("th", null, "平均成交价"),
    /*#__PURE__*/_createElementVNode("th", null, "仓位变化"),
    /*#__PURE__*/_createElementVNode("th", null, "方向"),
    /*#__PURE__*/_createElementVNode("th", null, "调仓原因")
  ])
], -1))
const _hoisted_11 = ["onDblclick"]
const _hoisted_12 = { class: "name-cell" }
const _hoisted_13 = { class: "reason-cell" }
const _hoisted_14 = {
  key: 0,
  class: "empty-row"
}
const _hoisted_15 = {
  colspan: "7",
  class: "empty-cell"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StockCodeDisplay = _resolveComponent("StockCodeDisplay")!
  const _component_Nodata = _resolveComponent("Nodata")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showTitle)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_2, "调仓历史"))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("p", null, _toDisplayString(_ctx.error), 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fetchData && _ctx.fetchData(...args))),
              class: "retry-button"
            }, "重试")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (record, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    ref_for: true,
                    ref: el => _ctx.setRowRef(el, record.date),
                    class: _normalizeClass(['table-row', { selected: _ctx.selectedDate === record.date }]),
                    onDblclick: ($event: any) => (_ctx.handleRowDoubleClick(record))
                  }, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(record.date)), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_StockCodeDisplay, {
                        symbol: record.symbol,
                        market: record.market,
                        "hk-delay": _ctx.hkDelay,
                        "us-delay": _ctx.usDelay,
                        theme: _ctx.theme
                      }, null, 8, ["symbol", "market", "hk-delay", "us-delay", "theme"])
                    ]),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(record.name), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatPrice(record.averagePrice)), 1),
                    _createElementVNode("td", {
                      style: _normalizeStyle({ color: _ctx.getChangeColor(record) })
                    }, _toDisplayString(_ctx.formatPositionChange(record)), 5),
                    _createElementVNode("td", {
                      style: _normalizeStyle({ color: _ctx.getDirectionColor(record) })
                    }, _toDisplayString(record.direction), 5),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(record.reason), 1)
                  ], 42, _hoisted_11))
                }), 128)),
                (_ctx.records.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                      _createElementVNode("td", _hoisted_15, [
                        _createVNode(_component_Nodata, {
                          mode: "vertical",
                          customdesc: "暂无数据"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
  ]))
}